import { useSetting } from '@wordpress/block-editor';

export const useSpacingOptions = () => {
    const spacingSizes = useSetting('spacing.spacingSizes');

    // Spacing options for the controls
    const spacingOptions = spacingSizes.map((size) => ({
        label: size.name, // Name from theme.json
        value: size.slug, // Slug from theme.json
    }));

    return spacingOptions;
};

export const createResetSpacingFunction = (setAttributes) => {
    return () => {
        setAttributes({
            paddingTop: '',
            paddingBottom: '',
            paddingLeft: '',
            paddingRight: '',
            marginTop: '',
            marginBottom: '',
            marginLeft: '',
            marginRight: '',
            paddingTopMobile: '',
            paddingBottomMobile: '',
            paddingLeftMobile: '',
            paddingRightMobile: '',
            marginTopMobile: '',
            marginBottomMobile: '',
            marginLeftMobile: '',
            marginRightMobile: '',
        });
    };
};